"use strict";

var _defineProperty = require("/home/runner/work/KEKPETS_FRONTEND/KEKPETS_FRONTEND/node_modules/@babel/runtime/helpers/defineProperty");

var _toConsumableArray = require("/home/runner/work/KEKPETS_FRONTEND/KEKPETS_FRONTEND/node_modules/@babel/runtime/helpers/toConsumableArray");

require("core-js/modules/es.promise.finally.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function e(e) {
  return e && "object" == typeof e && "default" in e ? e.default : e;
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});
var t = e(require("effector"));

var o = function o(e, t) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return "object" != typeof e || null === e || (e.config && o(e.config, t, n), function (e, t, o) {
    o.filter(function (t) {
      return void 0 !== e[t];
    }).forEach(function (o) {
      t[o] = e[o];
    });
  }(e, n, t), e.ɔ && o(e.ɔ, t, n)), n;
};

var n = {
  readConfig: o
};

var r = t.createStore,
    s = t.createEvent,
    c = t.guard,
    i = t.merge,
    a = t.sample,
    u = t.withRegion,
    f = t.is,
    m = n.readConfig,
    l = function l(e) {
  throw new Error(e);
};

var d = function d(e) {
  var _m = m(e, ["loc", "name", "events", "reset", "target"]),
      t = _m.loc,
      _m$name = _m.name,
      o = _m$name === void 0 ? "unknown" : _m$name,
      n = _m.events,
      d = _m.reset,
      p = _m.target,
      g = p || s({
    name: o
  });

  return f.unit(g) || l("target should be a unit"), d && !f.unit(d) && l("reset should be a unit"), u(g, function () {
    var e = Array.isArray(n),
        s = Object.keys(n),
        u = e ? _toConsumableArray(s).fill() : {},
        f = r(s.length, {
      name: o + "Counter",
      loc: t
    }),
        m = r(u, {
      name: o + "Results",
      loc: t
    });
    f.reset(a(g)), m.reset(g), d && (f.reset(a(d)), m.reset(d));

    var _loop = function _loop() {
      var t = _s[_i];
      var o = r(!1).on(n[t], function () {
        return !0;
      }).reset(g);
      d && o.reset(d), f.on(o, function (e) {
        return e - 1;
      }), m.on(n[t], function (o, n) {
        var r = e ? _toConsumableArray(o) : _objectSpread({}, o);
        return r[t] = n, r;
      });
    };

    for (var _i = 0, _s = s; _i < _s.length; _i++) {
      _loop();
    }

    c({
      source: a(m, i(Object.values(n))),
      filter: f.map(function (e) {
        return 0 === e;
      }),
      target: g
    });
  }), g;
};

var p = t.is,
    g = t.guard,
    v = t.createEvent,
    h = n.readConfig;

function y(e) {
  return p.unit(e) ? e.map(function (e) {
    return !e;
  }) : function (t) {
    return !e(t);
  };
}

var b = function b(e) {
  var _h = h(e, ["name", "source", "if", "then", "else"]),
      _h$name = _h.name,
      t = _h$name === void 0 ? "unknown" : _h$name,
      _h$source = _h.source,
      o = _h$source === void 0 ? v({
    name: t + "Source"
  }) : _h$source,
      n = _h.if,
      r = _h.then,
      s = _h.else,
      c = p.unit(n) || "function" == typeof n ? n : function (e) {
    return e === n;
  };

  return r && g({
    source: o,
    filter: c,
    target: r
  }), s && g({
    source: o,
    filter: y(c),
    target: s
  }), o;
};

var w = t.is,
    E = t.createEffect,
    C = t.forward,
    T = t.createEvent,
    x = n.readConfig;

var k = function k(e) {
  var _x = x(e, ["source", "timeout", "target", "loc", "name", "sid"]),
      t = _x.source,
      o = _x.timeout,
      n = _x.target,
      r = _x.sid,
      s = _x.loc,
      c = _x.name;

  if (!w.unit(t)) throw new TypeError("source must be unit from effector");
  if (w.domain(t)) throw new TypeError("source cannot be domain");
  if ("number" != typeof o || o < 0 || !Number.isFinite(o)) throw new Error("timeout must be positive number or zero. Received: \"".concat(o, "\""));
  var i = c || t.shortName || "unknown";
  var a, u;
  var f = n || T({
    name: i + "DebounceTick",
    loc: s
  }),
      m = E({
    name: i + "DebounceTimer",
    sid: r,
    loc: s,
    handler: function handler(e) {
      return clearTimeout(u), a && a(), new Promise(function (t, n) {
        a = n, u = setTimeout(t, o, e);
      });
    }
  });
  return C({
    from: t,
    to: m
  }), C({
    from: m.done.map(function (_ref) {
      var e = _ref.result;
      return e;
    }),
    to: f
  }), f;
};

var N = t.is;

function S(e) {
  return N.store(e) ? "store" : N.effect(e) ? "effect" : N.event(e) ? "event" : N.domain(e) ? "domain" : N.unit(e) ? "unit" : "unknown";
}

function j(e, t) {
  var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  var n = o + D(e);
  e.watch(function (e) {
    console.info("[".concat(t, "] ").concat(n), e);
  });
}

function P(e) {
  j(e.done, "effect", D(e) + "."), j(e.fail, "effect", D(e) + ".");
}

function D(e) {
  return e.compositeName && e.compositeName.fullName ? e.compositeName.fullName : e.shortName ? e.shortName : e.name ? e.name : "";
}

var $ = function $() {
  var e = Array.from(arguments);

  for (var _i2 = 0, _e = e; _i2 < _e.length; _i2++) {
    var _t = _e[_i2];

    var _e2 = S(_t);

    _t.watch && j(_t, _e2), "effect" === _e2 && P(_t), "domain" === _e2 && (_t.onCreateEvent(function (e) {
      return j(e, "event");
    }), _t.onCreateStore(function (e) {
      return j(e, "store");
    }), _t.onCreateEffect(P));
  }
};

var F = t.createEffect,
    M = t.createEvent,
    _ = t.forward,
    A = t.is,
    O = t.sample,
    R = n.readConfig;

var z = function z(e) {
  var _R = R(e, ["loc", "sid", "name", "source", "timeout", "target"]),
      t = _R.loc,
      _R$name = _R.name,
      o = _R$name === void 0 ? "unknown" : _R$name,
      n = _R.sid,
      r = _R.source,
      s = _R.timeout,
      _R$target = _R.target,
      c = _R$target === void 0 ? M({
    name: o + "Delayed",
    sid: n,
    loc: t
  }) : _R$target;

  if (!A.unit(r)) throw new TypeError("source must be a unit from effector");
  if (!A.unit(c)) throw new TypeError("target must be a unit from effector");

  var i = function (e) {
    if (A.store(e) || "function" == typeof e || "number" == typeof e) return e;
    throw new TypeError("'timeout' argument must be a function, Store, or a number. Passed \"".concat(typeof e, "\""));
  }(s),
      a = F({
    config: {
      name: o + "DelayTimer",
      loc: t
    },
    handler: function handler(_ref2) {
      var e = _ref2.payload,
          t = _ref2.milliseconds;
      return new Promise(function (o) {
        setTimeout(o, t, e);
      });
    }
  });

  return O({
    source: {
      milliseconds: i
    },
    clock: r,
    fn: function fn(_ref3, t) {
      var e = _ref3.milliseconds;
      return {
        payload: t,
        milliseconds: "function" == typeof e ? e(t) : e
      };
    },
    target: a
  }), _({
    from: a.doneData,
    to: c
  }), c;
};

var B = t.combine,
    V = n.readConfig;

var q = function q(e) {
  var _V = V(e, ["predicate", "stores"]),
      t = _V.predicate,
      o = _V.stores,
      n = "function" == typeof t ? t : function (e) {
    return e === t;
  };

  return B(o, function (e) {
    return e.every(n);
  });
};

var G = t.combine,
    H = n.readConfig;

var I = function I(e) {
  var _H = H(e, ["effects", "domain", "sid", "name", "loc"]),
      t = _H.effects,
      o = _H.domain,
      n = _H.sid,
      r = _H.name,
      s = _H.loc;

  if (o) {
    var _e3 = o.createStore(0, {
      sid: n,
      name: r,
      loc: s
    });

    return o.onCreateEffect(function (t) {
      _e3.on(t, function (e) {
        return e + 1;
      }).on(t.finally, function (e) {
        return e - 1;
      });
    }), _e3;
  }

  return G(t.map(function (e) {
    return e.inFlight;
  }), function (e) {
    return e.reduce(function (e, t) {
      return e + t;
    }, 0);
  });
};

var J = t.combine,
    K = t.is,
    L = n.readConfig,
    Q = {
  some: function some(e) {
    return e.some(Boolean);
  },
  every: function every(e) {
    return e.every(Boolean);
  }
};

var U = function U(e) {
  var _L = L(e, ["effects", "domain", "of"]),
      t = _L.effects,
      o = _L.domain,
      _L$of = _L.of,
      n = _L$of === void 0 ? "some" : _L$of;

  if (!K.domain(o) && !t) throw new TypeError("domain or effects should be passed");
  if ("some" !== n && "every" !== n) throw new TypeError("strategy parameter \"of\" can be \"every\" or \"some\". Passed: \"".concat(n, "\""));
  var r = t;
  var s = Q[n];
  return o && (r = [], o.onCreateEffect(function (e) {
    return r.push(e);
  })), J(r.map(function (e) {
    return e.pending;
  }), s);
};

var W = n.readConfig;

var X = function X(e) {
  var _W = W(e, ["source", "shape"]),
      t = _W.source,
      o = _W.shape,
      n = {};

  for (var _e4 in o) {
    if (_e4 in o) {
      (function () {
        var r = o[_e4];
        n[_e4] = t.map(function (e) {
          var t = r(e);
          return void 0 === t ? null : t;
        });
      })();
    }
  }

  return n;
};

var Y = t.combine,
    Z = n.readConfig;

var ee = function ee(e) {
  var _Z = Z(e, ["predicate", "stores"]),
      t = _Z.predicate,
      o = _Z.stores,
      n = "function" == typeof t ? t : function (e) {
    return e === t;
  };

  return Y(o, function (e) {
    return e.some(n);
  });
};

var te = t.is,
    oe = n.readConfig;

var ne = function ne(e) {
  var _oe = oe(e, ["source", "cases"]),
      t = _oe.source,
      o = _oe.cases,
      n = {};

  var r = te.store(t) ? t.updates : t;

  for (var _e5 in o) {
    if (_e5 in o) {
      (function () {
        var t = o[_e5];
        n[_e5] = r.filterMap(t), r = r.filter({
          fn: function fn(e) {
            return !t(e);
          }
        });
      })();
    }
  }

  return n.__ = r, n;
};

var re = t.createEvent,
    se = t.sample,
    ce = t.guard,
    ie = n.readConfig;

var ae = function ae(e) {
  var _ie = ie(e, ["loc", "name", "source", "targets"]),
      t = _ie.loc,
      _ie$name = _ie.name,
      o = _ie$name === void 0 ? "unknown" : _ie$name,
      _ie$source = _ie.source,
      n = _ie$source === void 0 ? re({
    loc: t,
    name: o + "Source"
  }) : _ie$source,
      r = _ie.targets;

  var _loop2 = function _loop2(_e6) {
    if (_e6 in r) {
      var _t2 = ce({
        source: n,
        filter: function filter(t) {
          return "object" == typeof t && null !== t && _e6 in t;
        }
      });

      se({
        source: _t2,
        fn: function fn(t) {
          return t[_e6];
        },
        target: r[_e6]
      });
    }
  };

  for (var _e6 in r) {
    _loop2(_e6);
  }

  return n;
};

var ue = t.createStore,
    fe = n.readConfig;

var me = function me(e) {
  var _fe = fe(e, ["sid", "name", "loc", "effect", "defaultValue"]),
      t = _fe.sid,
      o = _fe.name,
      n = _fe.loc,
      r = _fe.effect,
      _fe$defaultValue = _fe.defaultValue,
      s = _fe$defaultValue === void 0 ? "initial" : _fe$defaultValue,
      c = ue(s, {
    sid: t,
    loc: n,
    name: o
  });

  return c.on(r, function () {
    return "pending";
  }).on(r.done, function () {
    return "done";
  }).on(r.fail, function () {
    return "fail";
  }), c;
};

var le = t.createEffect,
    de = t.createEvent,
    pe = t.guard,
    ge = t.is,
    ve = t.sample,
    he = n.readConfig;

var ye = d,
    be = b,
    we = k,
    Ee = $,
    Ce = z,
    Te = q,
    xe = I,
    ke = U,
    Ne = X,
    Se = ee,
    je = ne,
    Pe = ae,
    De = me,
    $e = function $e(e) {
  var _he = he(e, ["source", "timeout", "target", "loc", "name", "sid"]),
      t = _he.source,
      o = _he.timeout,
      n = _he.target,
      r = _he.sid,
      s = _he.loc,
      c = _he.name;

  if (!ge.unit(t)) throw new TypeError("source must be unit from effector");
  if ("number" != typeof o || o < 0) throw new Error("timeout must be positive number or zero");
  var i = c || t.shortName || "unknown",
      a = n || de({
    name: i + "ThrottleTick",
    loc: s
  }),
      u = le({
    name: i + "ThrottleTimer",
    sid: r,
    loc: s,
    handler: function handler() {
      return new Promise(function (e) {
        return setTimeout(e, o);
      });
    }
  });
  return pe({
    source: t,
    filter: u.pending.map(function (e) {
      return !e;
    }),
    target: u
  }), ve({
    source: t,
    clock: u.done,
    target: a
  }), a;
},
    Fe = {
  combineEvents: ye,
  condition: be,
  debounce: we,
  debug: Ee,
  delay: Ce,
  every: Te,
  inFlight: xe,
  pending: ke,
  reshape: Ne,
  some: Se,
  splitMap: je,
  spread: Pe,
  status: De,
  throttle: $e
};

exports.combineEvents = ye, exports.condition = be, exports.debounce = we, exports.debug = Ee, exports.default = Fe, exports.delay = Ce, exports.every = Te, exports.inFlight = xe, exports.pending = ke, exports.reshape = Ne, exports.some = Se, exports.splitMap = je, exports.spread = Pe, exports.status = De, exports.throttle = $e;